import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { TableAction } from "@app/shared/model/action.model";

@Component({
    selector: "table-custom-action-collapsed",
    templateUrl: "./table-custom-action-collapsed.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCustomActionCollapsedComponent {
    @Input() actionList: TableAction[] = [];

    preventClick($event) {
        $event?.stopPropagation();
    }

    emitTableAction($event, action: TableAction) {
        this.preventClick($event);
        if (typeof action.emitAction === "function") {
            action.emitAction();
        }
    }
}
